export default __webpack_public_path__ + "static/media/hair_dryer.d0f1379a.svg";